// ========================================
// Category Dashboards — Panel Logística, diseño A (2026-10-26)
// Lo pendiente arriba, las cifras del material, los préstamos de rodaje, la disponibilidad,
// el mapa de aulas (el plano y las aulas del Mapa interactivo, con su estado ahora), el
// material por categoría, las reservas por mes y las herramientas. Bloques personalizables
// como el Inicio (DashboardView); estilos en inicio.css (.inv-*) y logistica.css (.lo-*).
// ========================================

Object.assign(window.CategoryDashboards, {
    _loFloor: null,
    _loZone: null,

    renderLogistica() {
        const D = DashboardView;
        const items = typeof InventoryService !== 'undefined' ? InventoryService.getAllItems() : [];
        const requests = typeof WarehouseService !== 'undefined' ? WarehouseService.getAllRequests() : [];
        const orders = typeof WarehouseService !== 'undefined' ? WarehouseService.getAllOrders() : [];
        const today = D._iso(new Date());
        if (typeof FileStorage !== 'undefined' && FileStorage.needClasses) {
            FileStorage.needClasses(new Date(), new Date(), () => { if (App.currentView === 'logistica') this.reRenderDashboard('logistica'); });
        }
        // Las unidades que hay (quantity) y las que tiene el centro (totalQuantity).
        const total = items.reduce((sum, i) => sum + (Number(i.totalQuantity ?? i.quantity) || 0), 0);
        const available = items.reduce((sum, i) => sum + (Number(i.quantity) || 0), 0);
        const ctx = { items, requests, orders, today, total, available,
            names: new Map(items.map(i => [i.id, i.name])),
            active: requests.filter(r => ['approved', 'picked_up'].includes(r.status)),
            low: items.filter(i => Number(i.quantity) <= 2).sort((a, b) => Number(a.quantity) - Number(b.quantity)) };
        this._lastLogisticaCtx = ctx;
        const isEditMode = this.isEditMode('logistica');
        const widgetsConfig = this.getWidgetsConfig('logistica');
        const now = new Date(), day = now.toLocaleDateString('es-ES', { weekday: 'long', day: 'numeric', month: 'long' });
        const loans = ctx.active.filter(r => r.status === 'picked_up').length;

        return `
        <div class="dnr-proposal inicio-view lo-view">
            <section class="inv-head">
                <div class="inv-head-text">
                    <h1 class="inv-title">Logística y almacén</h1>
                    <p class="inv-sub">${Utils.sanitizeHTML(day.charAt(0).toUpperCase() + day.slice(1))} · ${items.length} referencias · ${total} unidades · ${loans} ${loans === 1 ? 'préstamo' : 'préstamos'} en curso</p>
                </div>
                <button type="button" id="btn-cog-logistica" class="inv-btn" style="display: ${isEditMode ? 'none' : 'flex'};" ${UIEvents.attr('click', () => CategoryDashboards.toggleWidgetDrawer('logistica'))}>
                    <i class="fas fa-sliders" aria-hidden="true"></i> Personalizar
                </button>
            </section>
            ${D._renderDrawer(widgetsConfig, isEditMode, 'logistica', 'Personalizar el panel')}
            ${D._renderEditBanner(isEditMode, 'logistica', 'el panel')}
            <div id="widgets-grid-logistica" class="dnr-widget-grid inv-grid">
                ${widgetsConfig.map((w, i) => this.renderLogisticaWidget(w, isEditMode, ctx, i)).join('')}
            </div>
        </div>`;
    },

    renderLogisticaWidget(w, isEditMode, ctx, i) {
        const builders = {
            'lo-pendiente': () => this._loPendiente(ctx),
            'lo-cifras': () => this._loCifras(ctx),
            'lo-prestamos': () => this._loPrestamos(ctx),
            'lo-disponibilidad': () => this._loDisponibilidad(ctx),
            'lo-mapa': () => this._loMapa(),
            'lo-categorias': () => this._loCategorias(ctx),
            'lo-meses': () => this._loMeses(ctx),
            'lo-herramientas': () => this._loHerramientas()
        };
        if (!builders[w.id]) return '';
        return DashboardView._dnrWidgetShell(w, isEditMode, builders[w.id](), i, 'logistica');
    },

    _loRepaint(id) {
        const card = document.getElementById('widget-' + id);
        const config = this.getWidgetsConfig('logistica'), w = config.find(x => x.id === id);
        if (!card || !w || !this._lastLogisticaCtx) return;
        SafeHTML.replace(card, this.renderLogisticaWidget(w, this.isEditMode('logistica'), this._lastLogisticaCtx, config.indexOf(w)));
    },

    // Abre el almacén en una de sus pestañas.
    _loGo(tab) {
        App.navigate('almacen');
        if (tab && typeof WarehouseView !== 'undefined') setTimeout(() => { if (App.currentView === 'almacen') WarehouseView.switchTab(tab); }, 0);
    },

    _loItems(r, ctx) {
        const list = AccionesPendientesView._items(r.items);
        return list.map(i => `${i.quantity > 1 ? `${i.quantity}× ` : ''}${i.name || ctx.names.get(i.itemId) || i.itemId}`).join(', ') || 'Material de rodaje';
    },

    _loPendiente(ctx) {
        const t = ctx.today;
        const items = [
            { n: ctx.requests.filter(r => r.status === 'pending').length, label: 'Reservas por aprobar', sub: 'Solicitudes de material', tone: 'is-warn', tab: 'requests' },
            { n: ctx.active.filter(r => r.status === 'approved' && r.dates?.from && r.dates.from <= t).length, label: 'Por entregar', sub: 'Aprobadas que recogen hoy o ya', tone: 'is-ok', tab: 'requests' },
            { n: ctx.active.filter(r => r.status === 'picked_up' && r.dates?.to && r.dates.to < t).length, label: 'Devoluciones atrasadas', sub: 'Pasada la fecha de vuelta', tone: 'is-bad', tab: 'requests' },
            { n: ctx.orders.filter(o => o.status === 'pending').length, label: 'Compras por firmar', sub: 'Órdenes de compra', tone: 'is-warn', tab: 'orders' },
            { n: ctx.low.length, label: 'Stock crítico', sub: '2 unidades o menos', tone: 'is-bad', tab: 'inventory' }
        ];
        const open = items.filter(i => i.n > 0), total = open.reduce((s, i) => s + i.n, 0);
        return `
            <div class="inv-card-head"><h2 class="inv-card-title">Pendiente ${total ? `<span class="inv-badge is-warn">${total}</span>` : ''}</h2></div>
            ${open.length ? `<div class="inv-pend-grid">
                ${open.map(i => `
                    <button type="button" class="inv-pend lo-pend ${i.tone}" ${UIEvents.attr('click', () => this._loGo(i.tab))}>
                        <span class="inv-pend-n">${i.n}</span>
                        <span class="inv-pend-text"><strong>${i.label}</strong><span>${i.sub}</span></span>
                    </button>`).join('')}
            </div>` : '<p class="inv-empty">Todo al día en el almacén.</p>'}`;
    },

    _loCifras(ctx) {
        const D = DashboardView, monday = D._monday(), from = D._iso(monday), to = D._iso(new Date(monday.getFullYear(), monday.getMonth(), monday.getDate() + 6));
        const week = ctx.requests.filter(r => r.dates?.from && r.dates.from >= from && r.dates.from <= to);
        const confirmed = week.filter(r => ['approved', 'picked_up', 'returned'].includes(r.status)).length, pending = week.filter(r => r.status === 'pending').length;
        // Sin inventario no hay porcentaje que dar (antes salía un 75 % / 25 % inventado).
        const pct = n => ctx.total > 0 ? Math.round(n / ctx.total * 100) : null;
        const shelf = pct(ctx.available), out = ctx.total > 0 ? 100 - shelf : null;
        const cells = [
            { label: 'Referencias', value: ctx.items.length, sub: `${ctx.total} unidades en total`, bar: ctx.items.length ? 100 : 0, barTone: 'is-mute', tab: 'inventory' },
            { label: 'En estantería', value: shelf === null ? '—' : `${shelf} %`, sub: `${ctx.available} unidades`, bar: shelf || 0, tone: 'is-ok', tab: 'inventory' },
            { label: 'En préstamo', value: out === null ? '—' : `${out} %`, sub: `${Math.max(0, ctx.total - ctx.available)} unidades`, bar: out || 0, tone: 'is-warn', barTone: 'is-warn', tab: 'requests' },
            { label: 'Reservas de la semana', value: week.length, sub: `${confirmed} ${confirmed === 1 ? 'confirmada' : 'confirmadas'} · ${pending} por aprobar`, bar: week.length ? Math.round(confirmed / week.length * 100) : 0, tab: 'requests' }
        ];
        return `
            <div class="inv-money">
                ${cells.map(c => `
                    <button type="button" class="inv-money-cell" ${UIEvents.attr('click', () => this._loGo(c.tab))}>
                        <span class="inv-label">${c.label}</span>
                        <span class="inv-money-value ${c.tone || ''}">${c.value}</span>
                        <span class="inv-money-sub">${c.sub}</span>
                        <span class="inv-bar ${c.barTone || ''}" aria-hidden="true"><i style="width:${c.bar}%"></i></span>
                    </button>`).join('')}
            </div>`;
    },

    _loPrestamos(ctx) {
        const D = DashboardView, t = ctx.today;
        const days = iso => Math.round((new Date(`${iso}T12:00:00`) - new Date(`${t}T12:00:00`)) / 86400000);
        const short = iso => new Date(`${iso}T12:00:00`).toLocaleDateString('es-ES', { day: 'numeric', month: 'short' }).replace('.', '');
        const rows = ctx.active.map(r => {
            const out = r.status === 'picked_up', due = out ? r.dates?.to : r.dates?.from, d = due ? days(due) : null;
            const text = !due ? (out ? 'En rodaje' : 'Aprobado') : out
                ? (d < 0 ? `Atrasado ${-d} ${d === -1 ? 'día' : 'días'}` : d === 0 ? 'Vuelve hoy' : `Vuelve el ${short(due)}`)
                : (d <= 0 ? 'Recoge hoy' : `Recoge el ${short(due)}`);
            return { r, out, d, text, tone: out && d !== null && d < 0 ? 'is-bad' : d === 0 ? 'is-warn' : !out ? 'is-ok' : '' };
        }).sort((a, b) => (a.d ?? 999) - (b.d ?? 999));
        const late = rows.filter(x => x.tone === 'is-bad').length, onLoan = rows.filter(x => x.out).length;
        return `
            ${D._head(`Préstamos de rodaje <span class="inv-muted">${onLoan} en curso${late ? ` · ${late} ${late === 1 ? 'atrasado' : 'atrasados'}` : ''}</span>`, { label: 'Almacén', go: () => this._loGo('requests') })}
            <div class="inv-list">
                ${rows.length ? rows.slice(0, 6).map(x => `
                    <button type="button" class="lo-loan" ${UIEvents.attr('click', () => this._loGo('requests'))}>
                        <span class="inv-person-text"><strong>${Utils.sanitizeHTML(x.r.studentName || 'Alumno')}</strong><span>${Utils.sanitizeHTML(this._loItems(x.r, ctx))}</span></span>
                        <span class="inv-pill ${x.out ? '' : 'is-ok'}">${x.out ? 'En rodaje' : 'Aprobado'}</span>
                        <span class="lo-due ${x.tone}">${x.text}</span>
                    </button>`).join('') : '<p class="inv-empty">No hay préstamos en curso.</p>'}
            </div>`;
    },

    _loDisponibilidad(ctx) {
        const D = DashboardView, shelf = ctx.total ? Math.round(ctx.available / ctx.total * 100) : 0;
        return `
            ${D._head('Disponibilidad', { label: 'Inventario', go: () => this._loGo('inventory') })}
            ${ctx.total ? `
                <span class="lo-split" aria-hidden="true"><i style="width:${shelf}%"></i><i class="is-out" style="width:${100 - shelf}%"></i></span>
                <div class="inv-line lo-static"><span>En estantería</span><strong>${ctx.available} · ${shelf} %</strong></div>
                <div class="inv-line lo-static"><span>En préstamo</span><strong>${ctx.total - ctx.available} · ${100 - shelf} %</strong></div>` : '<p class="inv-empty">Todavía no hay material en el inventario.</p>'}
            <h3 class="inv-label">Stock crítico</h3>
            <div class="inv-list">
                ${ctx.low.length ? ctx.low.slice(0, 4).map(i => `
                    <div class="inv-line lo-static"><span>${Utils.sanitizeHTML(i.name || 'Artículo')}</span><strong class="lo-low">${Number(i.quantity) || 0}</strong></div>`).join('') : '<p class="inv-empty">Nada por debajo de 3 unidades.</p>'}
            </div>`;
    },

    // ── Mapa de aulas: el del Mapa interactivo (su plano y sus aulas), con el estado de ahora ──

    _loZones() {
        try {
            const zones = JSON.parse(FileStorage.getItem('ecpv_floorplan_zones') || '[]');
            return Array.isArray(zones) ? zones.filter(z => z && z.name).map(z => ({ ...z, floor: z.floor || 1 })) : [];
        } catch { return []; }
    },

    _loZoneState(zone, classes, hm) {
        const mine = classes.filter(c => String(c.classroom || '').trim().toLowerCase() === zone.name.trim().toLowerCase())
            .sort((a, b) => String(a.startTime || '').localeCompare(String(b.startTime || '')));
        const cur = mine.find(c => c.startTime <= hm && hm < (c.endTime || c.startTime)), next = mine.find(c => c.startTime > hm);
        return { mine, cur, next, state: cur ? 'now' : next ? 'later' : 'free' };
    },

    _loMapa() {
        const D = DashboardView, zones = this._loZones(), now = new Date();
        const hm = `${String(now.getHours()).padStart(2, '0')}:${String(now.getMinutes()).padStart(2, '0')}`;
        const classes = D._classesOn(D._iso(now));
        // Both plans always (the Mapa interactivo has two floors), also before any room is drawn.
        const floors = [...new Set([1, 2, ...zones.map(z => z.floor)])].sort();
        const floor = floors.includes(this._loFloor) ? this._loFloor : (floors[0] || 1);
        const onFloor = zones.filter(z => z.floor === floor).map(z => ({ z, ...this._loZoneState(z, classes, hm) }));
        const inUse = new Set(classes.filter(c => String(c.classroom || '').trim() && c.startTime <= hm && hm < (c.endTime || c.startTime)).map(c => c.classroom.trim().toLowerCase())).size;
        const sel = onFloor.find(x => x.z.id === this._loZone) || onFloor.find(x => x.state === 'now') || onFloor[0];
        // Rooms with classes today, from the timetable (also the ones not drawn on the plan).
        const drawn = new Set(zones.map(z => z.name.trim().toLowerCase()));
        const todayRooms = [...new Set(classes.map(c => String(c.classroom || '').trim()).filter(Boolean))].sort((a, b) => a.localeCompare(b, 'es'))
            .map(name => ({ name, drawn: drawn.has(name.toLowerCase()), ...this._loZoneState({ name }, classes, hm) }));
        const label = { now: 'En uso', later: 'Libre', free: 'Libre' };
        const head = `
            <div class="inv-card-head">
                <h2 class="inv-card-title">Mapa de aulas <span class="inv-pill ${inUse ? 'is-bad' : ''}">${inUse} en uso · ${hm}</span></h2>
                ${floors.length > 1 ? `<div class="lo-floors" role="group" aria-label="Planta">
                    ${floors.map(f => `<button type="button" class="${f === floor ? 'is-on' : ''}" aria-pressed="${f === floor}" ${UIEvents.attr('click', () => { this._loFloor = f; this._loZone = null; this._loRepaint('lo-mapa'); })}>Planta ${f}</button>`).join('')}
                </div>` : ''}
                <button type="button" class="inv-link" ${UIEvents.attr('click', () => App.navigate('mapa-interactivo'))}>Mapa interactivo <span aria-hidden="true">→</span></button>
            </div>`;
        // Same plan images as the Mapa interactivo (interactive-map.js).
        return `
            ${head}
            <div class="lo-map-wrap">
                <div class="lo-map ${floor === 2 ? 'is-floor-2' : ''}" role="group" aria-label="Plano de la planta ${floor}" style="background-image: url('${floor === 2 ? '/assets/plano_instalaciones_p2.jpg' : '/assets/plano_instalaciones.png'}');">
                    ${onFloor.map(x => `
                        <button type="button" class="lo-zone is-${x.state} ${sel && sel.z.id === x.z.id ? 'is-sel' : ''}" style="left:${Number(x.z.x) || 0}%; top:${Number(x.z.y) || 0}%; width:${Number(x.z.width) || 0}%; height:${Number(x.z.height) || 0}%;"
                            aria-label="${Utils.sanitizeHTML(`${x.z.name}: ${x.state === 'now' ? 'en uso' : 'libre'}`)}" ${UIEvents.attr('click', () => { this._loZone = x.z.id; this._loRepaint('lo-mapa'); })}>
                            <strong>${Utils.sanitizeHTML(x.z.name)}</strong>
                            <span class="lo-zone-badge">${x.state === 'now' ? 'Ocupado' : x.state === 'later' ? `A las ${Utils.sanitizeHTML(x.next.startTime)}` : 'Libre'}</span>
                        </button>`).join('')}
                </div>
                <div class="lo-map-side">
                    ${!zones.length ? `
                        <div class="lo-map-detail">
                            <strong>Aulas con clase hoy</strong>
                            ${todayRooms.length ? todayRooms.map(r => `
                                <span class="lo-room-row"><span>${Utils.sanitizeHTML(r.name)}</span><span class="inv-pill ${r.state === 'now' ? 'is-bad' : r.state === 'later' ? 'is-warn' : 'is-ok'}">${r.state === 'now' ? `En uso hasta ${Utils.sanitizeHTML(r.cur.endTime || '')}` : r.state === 'later' ? `A las ${Utils.sanitizeHTML(r.next.startTime)}` : 'Libre'}</span></span>`).join('') : '<span class="inv-muted">Hoy no hay clases con aula asignada.</span>'}
                        </div>
                        <p class="inv-empty lo-map-hint">Dibuja las aulas en el <button type="button" class="inv-link" ${UIEvents.attr('click', () => App.navigate('mapa-interactivo'))}>Mapa interactivo</button> y saldrán también sobre el plano, con su estado.</p>` : ''}
                    ${sel ? `
                        <div class="lo-map-detail">
                            <span class="inv-pill ${sel.state === 'now' ? 'is-bad' : sel.state === 'later' ? 'is-warn' : 'is-ok'}">${label[sel.state]}</span>
                            <strong>${Utils.sanitizeHTML(sel.z.name)}</strong>
                            ${sel.mine.length ? sel.mine.map(c => `<span><span class="inv-mono">${Utils.sanitizeHTML(`${c.startTime || ''}–${c.endTime || ''}`)}</span> ${Utils.sanitizeHTML(CategoryDashboards._acaNames(c).subject)}</span>`).join('') : '<span class="inv-muted">Sin clases hoy.</span>'}
                        </div>` : ''}
                    <div class="lo-legend" ${zones.length ? '' : 'hidden'}>
                        <span><i class="is-now"></i>Ocupado ahora</span>
                        <span><i class="is-later"></i>Libre, con clase más tarde</span>
                        <span><i class="is-free"></i>Libre el resto del día</span>
                    </div>
                </div>
            </div>`;
    },

    _loCategorias(ctx) {
        const D = DashboardView, byCat = new Map();
        for (const i of ctx.items) byCat.set(i.category || 'Sin categoría', (byCat.get(i.category || 'Sin categoría') || 0) + (Number(i.totalQuantity ?? i.quantity) || 0));
        const rows = [...byCat].sort((a, b) => b[1] - a[1]), max = Math.max(1, ...rows.map(r => r[1]));
        return `
            ${D._head('Material por categoría', { label: 'Inventario', go: () => this._loGo('inventory') })}
            ${rows.length ? `<div class="inv-funnel lo-cats">
                ${rows.slice(0, 8).map(([name, n]) => `
                    <span class="inv-funnel-l" title="${Utils.sanitizeHTML(name)}">${Utils.sanitizeHTML(name)}</span>
                    <span class="inv-bar" aria-hidden="true"><i style="width:${Math.round(n / max * 100)}%"></i></span>
                    <strong class="inv-funnel-n">${n}</strong>`).join('')}
            </div>` : '<p class="inv-empty">Todavía no hay material en el inventario.</p>'}`;
    },

    _loMeses(ctx) {
        const D = DashboardView, now = new Date();
        const months = [5, 4, 3, 2, 1, 0].map(back => {
            const d = new Date(now.getFullYear(), now.getMonth() - back, 1), ym = D._iso(d).slice(0, 7);
            return { name: d.toLocaleDateString('es-ES', { month: 'short' }).replace('.', '').toUpperCase(), n: ctx.requests.filter(r => String(r.createdAt || '').startsWith(ym)).length };
        });
        const max = Math.max(1, ...months.map(m => m.n)), total = months.reduce((s, m) => s + m.n, 0);
        return `
            ${D._head(`Reservas por mes <span class="inv-muted">${total} en 6 meses</span>`, null)}
            <div class="aca-bars lo-months">
                ${months.map(m => `
                    <div class="aca-bar">
                        <strong class="crm-month-n">${m.n}</strong>
                        <span class="aca-bar-track" aria-hidden="true"><i class="is-teal" style="height:${m.n ? Math.max(3, Math.round(m.n / max * 100)) : 0}%"></i></span>
                        <span class="inv-label">${m.name}</span>
                    </div>`).join('')}
            </div>`;
    },

    _loHerramientas() {
        const D = DashboardView;
        const tools = [
            ['Inventario', () => this._loGo('inventory'), 'almacen'], ['Reservas', () => this._loGo('requests'), 'almacen'], ['Compras', () => this._loGo('orders'), 'almacen'],
            ['Mapa de aulas', () => App.navigate('mapa-interactivo'), 'mapa-interactivo'], ['Distribución', () => App.navigate('distribucion'), 'distribucion']
        ].filter(t => D._can(t[2]));
        return `
            <nav class="aca-tools" aria-label="Herramientas de logística">
                ${tools.map(([label, go]) => `<button type="button" class="inv-quick-link" ${UIEvents.attr('click', go)}>${label}</button>`).join('')}
            </nav>`;
    }
});
